import React, { useState } from 'react'
import "./users.scss"
import { GridColDef } from "@mui/x-data-grid";
import DataTable from '../../components/dataTable/DataTable.tsx'
import Add from '../../components/add/Add.tsx';

const columns: GridColDef[] = [
  { field: '_id', headerName: 'ID', width: 50 },
  {
    field: 'userAvatar', headerName: "Avatar", width: 60,
    renderCell: (params) => {
      return <img src={params.row.img || "/noavatar.png"} alt="" />
    }
  },
  { field: 'userName', headerName: "Benutzername", width: 150 },
  { field: 'lastName', headerName: "Nachname", width: 90 },
  { field: 'firstName', headerName: "Vorname", width: 90 },
  { field: 'email', headerName: "E-Mail", width: 200 },
  { field: 'organizationName', headerName: "Gemeinde", width: 150 },
  { field: 'isAdmin', headerName: "Admin", width: 70, type: 'boolean' },
  { field: 'lastLogin', headerName: "letzter Login", width: 130 },
];

const rows = [
  { _id: 1, lastName: 'Stebner', firstName: 'Martin', email: 'martin.stebner@lkleer.de', userName: 'maddin', organizationName: 'LK Leer', isAdmin: true, lastLogin: '26.04.2025 10:39' },
  { _id: 2, lastName: 'Snow', firstName: 'Jon', age: 35 },
];

const Users = () => {
  const [open, setOpen] = useState(false)
  return (
    <div className="users">
      <div className="info">
        <h1>Benutzer</h1>
        <button onClick={() => setOpen(true)}>Neuen Benutzer anlegen</button>
      </div>
      <DataTable header="Benutzer" slug="users" columns={columns} rows={rows}/>
      {open && <Add header="Neuen Benutzer hinzufügen" slug='user' columns={columns} setOpen={setOpen}/>}
    </div>
  )
}

export default Users
